// ─────────────────────────────────────────────────────────────────────────────
// P4-7 — Celda "Creado por" de las dos tablas de encuestas (D-4: la columna se conserva).
//
// Hay TRES estados distintos que antes se pintaban como uno solo, y distinguirlos es justo lo
// que hacía falta para dejar de leer "Desconocido" sin saber por qué:
//
// 1. La encuesta no trae `createdBy` (o trae el centinela `'unknown'`). Son las de QA creadas
//    antes de que el frontend mandara `?userId=` — ver la nota del endpoint en `api/client.ts`.
//    El dato no existe y no se puede recuperar; se etiqueta como desconocido.
// 2. Trae un id que el directorio SÍ resuelve → se muestra el nombre.
// 3. Trae un id que el directorio NO resuelve (usuario dado de baja, id de otro tenant, o el
//    usuario de relleno de DevAuthMiddleware). Antes se imprimía el GUID crudo en la celda.
//    Ahora se etiqueta como desconocido y el id queda en el `title`, que es donde sirve.
// ─────────────────────────────────────────────────────────────────────────────
import { useTranslation } from 'react-i18next';

interface CreatedByCellProps {
  createdBy?: string;
  /** `usePersonNameResolver().resolvePersonName` — devuelve el id tal cual si no lo encuentra. */
  resolvePersonName: (personId: string) => string;
}

export function CreatedByCell({ createdBy, resolvePersonName }: CreatedByCellProps) {
  const { t } = useTranslation();

  if (!createdBy || createdBy === 'unknown') {
    return <span className="adm-created-by">{t('admin.creatorUnknown')}</span>;
  }

  const resolved = resolvePersonName(createdBy);
  if (resolved === createdBy) {
    return (
      <span className="adm-created-by" title={createdBy}>
        {t('admin.creatorUnknown')}
      </span>
    );
  }

  return <span className="adm-created-by">{resolved}</span>;
}
